import { hasArrayElements } from "@/apiUtils/commonUtils";
import NoImageSrc from "@/assets/images/no_image.svg";
import CldImage from "@/components/ui/cldImg/CldImage";
import { getCloudinaryURL } from "@/utils/cloudinary";
import { ShippingNReturnsTabProps } from "../../types";
import { useLayoutEffect, useRef } from "react";

const ShippingNReturns = ({
  data,
  label,
  id,
  altText,
}: ShippingNReturnsTabProps & { id?: string }) => {
  const parentDivRef = useRef<HTMLDivElement | null>(null)
  

  useLayoutEffect(() => {
    if(parentDivRef.current) {
      const allUls = Array.from(parentDivRef.current.querySelectorAll('ul'));

      for(const ul of allUls) {
        ul.style.marginLeft = '2.5rem';
        ul.style.listStyle = 'disc'

      }
    }
  },[])

  return (
    <div
      ref={parentDivRef}
      id={id}
      className="flex h-full flex-col-reverse items-center justify-center px-4 md:px-12 lg:flex-row text-sm md:text-base"
    >
      <div className="flex flex-1 flex-col items-center gap-6">
        <div className="w-full pt-5" dangerouslySetInnerHTML={{ __html: data.description }}></div>
      </div>
      <div className="justify-centers flex flex-1 items-center">
        <CldImage
          src={
            hasArrayElements(data.images) && data.images[0]
              ? getCloudinaryURL(data.images[0]?.url)
              : NoImageSrc.src
          }
          alt={altText}
          width={708}
          height={608}
          className="w-full invert-[2%]"
        />
      </div>
    </div>
  );
};

export default ShippingNReturns;
